<template>
  <div id="vendor-compliance-detail-container">
    <div class="vendor-compliance-detail">
      <div id="details-page-container" class="details-page-container">
        <div class="vcf-x vcf-wrapper vcf-package">
          <div class="vcf-container">
            <div class="vcf-layout-wrapper" style="height: auto;">
              <button @click="close" class="vcf-close is-large" aria-label="close"></button>
              <div style="margin: 20px;">
                <iframe class="responsive-iframe" :src="selectedFile.path"></iframe>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="vendor-compliance-detail-mask" role="presentation"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
        }
    },
    computed: {       
        ...mapGetters('compliance', {
            selectedFile: 'getSelectedFile'
        }),
    },
    methods: {
        close(){
            VueStore.dispatch('notify/setVariable', {key: 'viewComplianceFilesModal', value: false});
        }
    }
}
</script>

<style scoped>
body {
  margin: 0px;
  background: #FFF !important;
  height: 100%;
}

.vendor-compliance-detail-mask {
  z-index: 10009;
  opacity: .5;
  background-color: #000;
}

.vendor-compliance-detail {
  z-index: 10008;
  overflow: visible;
  font-size: 14px;
  display: block;
  color: #676C83 !important;
}

#vendor-compliance-detail-container #details-page-container {
  border: none;
  margin-bottom: 0;
  min-height: 100%;
  overflow: visible;
}

.vendor-compliance-detail,
.vendor-compliance-detail-mask {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}


#vendor-compliance-detail-container #details-page-container {
  max-width: calc(700px + 400px);
  width: calc(100vw - (72px * 2));
}

.vendor-compliance-detail .details-page-container {
  max-width: 684px;
  margin: 0 auto;
  position: relative;
}

.details-page-container {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background: #fff;
  z-index: 10010;
  overflow-y: visible;
}

.compliance-sub-nav {
  padding: 6px 10px 0px 10px;
  position: relative;
  border-bottom: 1px solid #e3e3e3;
  position: fixed;
  background-color: #FFFFFF;
  z-index: 9998 !important;
  max-width: calc(700px + 400px);
  width: calc(100vw - (72px * 2));
}

.compliance-sub-nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.compliance-sub-nav ul li.active {
  border-bottom: 3px solid #2776D9;
  color: #2776D9;
}

.compliance-sub-nav ul li:hover {
  cursor: pointer;
  color: #2776D9;
}

.compliance-sub-nav ul li {
  float: left;
  margin-right: 20px;
  font-size: 14px;
  line-height: 33px;
}

.vcf-wrapper {
  position: relative;
  z-index: 1;
}

.vcf-x {
  position: static;
  padding-top: 0px;
}


.vcf-package .vcf-container {
  position: static;
}

.vcf-container {
  -webkit-font-smoothing: antialiased;
  height: 100%;
  max-height: none;
  position: relative;
}

.vcf-close {
  position: absolute;
  top: 5px;
  right: -45px;
  border: none;
  background-image: none;
  background-color: transparent;
  box-shadow: none;
  padding: 0;
  display: none;
}

.vcf-close {
  /** background-color: rgb(10 10 10 / 52%); **/
  background-color: rgb(141, 140, 140);
  display: inline-block;
  width: 20px;
  height: 40px;
  width: 40px;
  z-index: 9999;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  border-radius: 290486px;
  cursor: pointer;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  max-height: 20px;
  max-width: 20px;
  min-height: 20px;
  min-width: 20px;
  outline: none;
  vertical-align: top;
}

.vcf-close.is-large {
  height: 42px;
  max-height: 42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  width: 42px;
}

.vcf-close:before {
  height: 2px;
  width: 50%;

}

.vcf-close:after {
  height: 50%;
  width: 2px;
}

.vcf-close:before,
.vcf-close:after {
  background-color: white;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform-origin: center center;
}

.vcf-close:hover {
  background-color: #aaa;
}


@media screen and (-webkit-min-device-pixel-ratio:0) {
  .iframe {
    zoom: 1;
  }
}


@media screen and (min-width: 769px) {

  .comp-modal-content,
  .modal-card {
    margin: 0 auto;
    /** width: 950px !important; **/
  }

  .vcf-wrapper {
    overflow: hidden;
    height: 100vh;
  }
}

@media only screen and (min-width: 1024px) {
  .vcf-close {
    display: block;
  }
}

.responsive-iframe {
  width: 100%;
  /* Set the iframe width to 100% of its container */
  height: 100vh;
  /* Set the iframe height to 100% of the viewport height */
}

/* Mobile/tablet: cover the whole viewport instead of the desktop inset
   width (100vw - 144px), scroll inside the modal if content exceeds it,
   and pull the close button back on-screen (it sits 45px outside the
   panel on desktop). The 1024px breakpoint matches the compliance
   section's own mobile layout breakpoint. */
@media screen and (max-width: 1024px) {
  #vendor-compliance-detail-container #details-page-container,
  .vendor-compliance-detail .details-page-container {
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    overflow-y: auto;
  }

  .vcf-close {
    right: 10px;
    top: 10px;
  }
}
</style>